import { forwardRef, type ElementType, type HTMLAttributes } from 'react';

import { cn } from '../../lib/cn';

export interface VisuallyHiddenProps extends HTMLAttributes<HTMLElement> {
  /** Defaults to `span`; use `caption` inside a table, `h1` for a page title. */
  readonly as?: ElementType;
}

/**
 * Text for assistive technology only.
 *
 * Not `display: none` and not `hidden` — both remove the node from the
 * accessibility tree, which is the opposite of the intent. This is the standard
 * clip-rect recipe, kept focusable-safe.
 */
export const VisuallyHidden = forwardRef<HTMLElement, VisuallyHiddenProps>(function VisuallyHidden(
  { as: Component = 'span', className, ...rest },
  ref,
) {
  return (
    <Component
      {...rest}
      ref={ref}
      className={cn(
        'absolute size-px overflow-hidden whitespace-nowrap border-0 p-0',
        '[clip:rect(0,0,0,0)] [clip-path:inset(50%)]',
        className,
      )}
    />
  );
});
